import loader from './loader.svg'

const Loader = () => {
    return (
      <div>
          <img
              src={loader}
              alt="loader"
              width={22}
              height={22}
          />
      </div>
    )
  }
  
  export default Loader